import SlsClienteContatoClient from '@/api/Cadastros/Cliente/sls-cliente-contato.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSClienteContatoService {
  constructor() {
    this.client = new SlsClienteContatoClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os Cliente');
    }
  }

  async findContatoCliente(queries) {
    try {
      const { data } = await this.client.getContatosCliente(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os Cliente');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Cliente');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Cliente');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.client.update(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Cliente');
    }
  }

  async destroy(body) {
    try {
      const { data: response } = await this.client.destroy(body);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Cliente');
    }
  }
}
